import { useQuery } from '@tanstack/react-query';
import { fetchAiSuggestions } from 'api/services/aiSuggestions';

const FETCH_AI_SUGGESTIONS_KEY = 'fetch-ai-suggestions';

const useAiSuggestionsQuery = (itemId: string) => {
  const query = useQuery({
    queryKey: [FETCH_AI_SUGGESTIONS_KEY, itemId],
    queryFn: () => fetchAiSuggestions(itemId),
    enabled: itemId != null ? true : false,
    staleTime: 1000 * 60 * 30,
    retry: false,
  });

  return query;
};

export default useAiSuggestionsQuery;

export { FETCH_AI_SUGGESTIONS_KEY };
